/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomPriceListsInfoByCompanyQueryVariables = Exact<{
  companyId: string;
}>;


export type CustomPriceListsInfoByCompanyQuery = { custom_price_list: Array<{ id: string, name: string }> };


export const CustomPriceListsInfoByCompanyDocument = /*#__PURE__*/ gql`
    query CustomPriceListsInfoByCompany($companyId: uuid!) {
  custom_price_list(where: {company_id: {_eq: $companyId}}, order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useCustomPriceListsInfoByCompanyQuery__
 *
 * To run a query within a React component, call `useCustomPriceListsInfoByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPriceListsInfoByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPriceListsInfoByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCustomPriceListsInfoByCompanyQuery(baseOptions: Apollo.QueryHookOptions<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables> & ({ variables: CustomPriceListsInfoByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>(CustomPriceListsInfoByCompanyDocument, options);
      }
export function useCustomPriceListsInfoByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>(CustomPriceListsInfoByCompanyDocument, options);
        }
// @ts-ignore
export function useCustomPriceListsInfoByCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>;
export function useCustomPriceListsInfoByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListsInfoByCompanyQuery | undefined, CustomPriceListsInfoByCompanyQueryVariables>;
export function useCustomPriceListsInfoByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>(CustomPriceListsInfoByCompanyDocument, options);
        }
export type CustomPriceListsInfoByCompanyQueryHookResult = ReturnType<typeof useCustomPriceListsInfoByCompanyQuery>;
export type CustomPriceListsInfoByCompanyLazyQueryHookResult = ReturnType<typeof useCustomPriceListsInfoByCompanyLazyQuery>;
export type CustomPriceListsInfoByCompanySuspenseQueryHookResult = ReturnType<typeof useCustomPriceListsInfoByCompanySuspenseQuery>;
export type CustomPriceListsInfoByCompanyQueryResult = Apollo.QueryResult<CustomPriceListsInfoByCompanyQuery, CustomPriceListsInfoByCompanyQueryVariables>;